'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentDisclaimer = function PaymentDisclaimer(_ref) {
  var lines = _ref.lines;

  var linesBroken = lines.map(function (line, i) {
    return (
      // eslint-disable-next-line react/no-array-index-key
      _react2.default.createElement(
        _react2.default.Fragment,
        { key: 'disclaimer-' + i },
        line,
        _react2.default.createElement('br', null)
      )
    );
  });
  return _react2.default.createElement(
    'p',
    { className: 'secondary' },
    linesBroken
  );
};

PaymentDisclaimer.propTypes = {
  lines: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.func])).isRequired
};

var PaymentExplanation = function PaymentExplanation(props) {
  var close = props.close,
      _props$viewOptions = props.viewOptions,
      message = _props$viewOptions.message,
      _props$viewOptions$ti = _props$viewOptions.title,
      title = _props$viewOptions$ti === undefined ? 'Confirm Transaction' : _props$viewOptions$ti,
      _props$viewOptions$ex = _props$viewOptions.extraFields,
      extraFields = _props$viewOptions$ex === undefined ? {} : _props$viewOptions$ex,
      _props$viewOptions$di = _props$viewOptions.disclaimers,
      disclaimers = _props$viewOptions$di === undefined ? [] : _props$viewOptions$di;


  var extraFieldRows = Object.keys(extraFields).map(function (field) {
    return _react2.default.createElement(
      'tr',
      { key: field, className: extraFields[field].rowClass },
      _react2.default.createElement(
        'td',
        { className: 'label' },
        field,
        ':'
      ),
      _react2.default.createElement(
        'td',
        { className: 'extraField' },
        extraFields[field].component
      )
    );
  });

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h2',
      null,
      title
    ),
    _react2.default.createElement(
      'p',
      null,
      message
    ),
    _react2.default.createElement(
      'table',
      null,
      _react2.default.createElement(
        'tbody',
        null,
        extraFieldRows
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'actions' },
      _react2.default.createElement(
        'button',
        { type: 'button', name: 'back', className: 'btn cancel', onClick: function onClick() {
            return close(false);
          } },
        'Back'
      ),
      _react2.default.createElement(
        'button',
        { type: 'button', name: 'continue', className: 'btn', onClick: function onClick() {
            return close(true);
          } },
        'Continue'
      ),
      _react2.default.createElement(PaymentDisclaimer, { lines: disclaimers })
    )
  );
};

var messageTypes = [_propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.func];

PaymentExplanation.propTypes = {
  viewOptions: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    message: _propTypes2.default.oneOfType(messageTypes),
    disclaimers: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType(messageTypes))
  }).isRequired,
  close: _propTypes2.default.func.isRequired
};

exports.default = PaymentExplanation;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/wallet/PaymentExplanation.js
// module id = 1278
// module chunks = 0